(function($) {

    // Get Window Width and Height
    var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).height();
  
    /* Document ready functions */
    jQuery(document).ready(function ($){
     


    // End ready functions  
    });
  
  })(jQuery);
  